import * as React from 'react';
import { AnEvent } from '../schedule/an-event';
import * as classNames from 'classnames';
import { Subscription } from 'rxjs/Subscription';
import { Observable } from 'rxjs/Observable';
import { App } from '../interfaces';
import { style } from "typestyle";
import * as csstips from 'csstips';
import Add from 'material-ui-icons/Add';
import { EventScheduleController } from './event-schedule-controller';
import { DateTime } from 'luxon';

export interface DayEventsProps {
  date: DateTime;
  controller: EventScheduleController;
}

export interface DayEventsState {
  events: App.EventListing[];
}

export class DayEvents extends React.Component<DayEventsProps, DayEventsState> {

  currentMomentSub: Subscription;
  eventsSub: Subscription;

  state: DayEventsState = {
    events: []
  };

  componentWillMount() {

    this.eventsSub = this.props.controller.getEventsForDay(this.props.date).subscribe(
      (events) => this.setState( { events })
    );

  }

  componentWillUnmount() {

    if(this.eventsSub) { this.eventsSub.unsubscribe(); }

  }

  handleOnEventListingClick(eventListing: App.EventListing) {

    window.location.href = eventListing.event.link;

  }

  render() {


    const events = this.state.events.map(
      event => <AnEvent key={event.id} onClick={ e => this.handleOnEventListingClick(e) } event={event}></AnEvent>
    );

    return (
        <div className= { 'day-events' }>
          { events }
        </div>
    );

  }


}


// WEBPACK FOOTER //
// ./resources/src/components/event-schedule/day-events.tsx